module.exports = __webpack_public_path__ + "static/media/34-9.c12c1171.mp3";